import { propertyAlgoliaQueryFn, propertyUseQuery } from 'Services/reactQuery'
import errorLogger from 'Root/errorLogger'
import { ALGOLIA_PREFIX } from 'Config/config'


export const fetchPopularAreas = async () => {
  const cityNames = ['Toronto', 'Vaughan', 'Vancouver', 'North York', 'Mississauga', 'Oakville']
  const filters = cityNames.map((name, idx) => `${idx > 0 ? ' OR ' : ''}display_name:"${name}"`).join('')
  let result = {
    nbHits: 0,
    hits: [],
  }
  try {
    result = await propertyAlgoliaQueryFn({
      query: [
        {
          indexName: ALGOLIA_PREFIX + 'search_areas',
          params: {
            filters,
            hitsPerPage: 6,
            attributesToRetrieve: ['title', 'subtitle', 'filter_type', 'url', 'filter_value'],
          },

        },
      ],
    })
  } catch(e) {
    errorLogger('algoliaPopularAreasSearch', e)
  }
  return Promise.resolve(result && result.nbHits ? { response: { data: { data: result.hits } } } : null)
}

export const useFetchPopularAreass = () => (
  propertyUseQuery(
    ['popularAreas'],
    () => fetchPopularAreas(),
    { enabled: true },
  )
)
